export class HrOrganizationResponsibilityKey {
    private static readonly keyPrefix = 'hrOrganizationResponsibility';
    public static title = `${HrOrganizationResponsibilityKey.keyPrefix}.title`;
    public static pageHeader = `${HrOrganizationResponsibilityKey.keyPrefix}.pageHeader`;
    public static beginDate=`${HrOrganizationResponsibilityKey.keyPrefix}.beginDate`;
    public static endDate=`${HrOrganizationResponsibilityKey.keyPrefix}.endDate`;
    public static perObjectDefinitionId=`${HrOrganizationResponsibilityKey.keyPrefix}.perObjectDefinitionId`;
    public static responsibilityText=`${HrOrganizationResponsibilityKey.keyPrefix}.responsibilityText`;
}
